import { api, getToken } from '../../utils/api';
import { API_PAGES, API_PROJECT, API_STATISTIC } from '../../Constants';
import {
  rxStripeKey,
  rxIsLoading,
  rxCurrentPage,
  rxBlocks,
  rxBlocksFetched,
  rxEditMode,
  rxUserName,
  rxPageId,
  rxProducts,
  rxProjectName,
  rxPageName,
  rxProjectId,
  rxError,
  eventEmiter,
  rxExitModalEnabled,
  rxExitModalData
} from '../rxState';

const getNext = (pages, order, pageId) => {
  if (!pageId) {
    return null;
  }
  let next;
  let nextPage;
  let name;
  order.forEach(item => {
    if (item.id === pageId) {
      for (const pageName in pages) {
        const page = pages[pageName];
        if (item.next === page._id) {
          nextPage = page;
          name = pageName;
        }
      }

      if (nextPage && nextPage.enabled) {
        next = {
          id: item.next,
          name
        };
      }
    }
  });

  if (next) {
    return next;
  }
  if (nextPage) {
    return getNext(pages, order, nextPage._id);
  }

  return null;
}

const RESERVED_FIELDS = ['message', '_navigation', '_message', '_info'];
export const rxFetchPages = ({ username, id, editMode, page, productMode, applyBlocks = true}) => {
  const result = editMode ? loadEditData(id) : loadLiveData(page, id);

  rxIsLoading.next('Loading initial data');
  result
    .then((data) => {

      if (!data) {
        data = {pages: {}}
      }
      if (!data.pages[page]) {
        data.pages[page] = [];
      }

      const pageData = data.pages[page];
      if (pageData.exitpopupenabled) {
        rxExitModalEnabled.next(pageData.exitpopupenabled);
      }

      if (pageData.exitpopupdata) {
        rxExitModalData.next(pageData.exitpopupdata);
      }

      rxCurrentPage.next(page);
      rxProducts.next(data.products);
      rxStripeKey.next(data.stripePublicKey);

      if (applyBlocks) {
        rxBlocks.next(pageData);
      }

      rxBlocksFetched.next(true);
      rxEditMode.next(editMode);
      // eventEmiter.next({
      //   type: 'add-alert',
      //   payload: {
      //     type: 'success',
      //     text: 'FETCHED',
      //     description: 'data fetched',
      //   },
      // });
    })
    .catch((err) => {
      console.log('FETCH ERROR', err)
      rxError.next(true);
      // eventEmiter.next({
      //   type: 'add-alert',
      //   payload: {
      //     type: 'error',
      //     text: 'API fetch data error',
      //     description: err.message,
      //   },
      // });
    })
    .finally(() => {
      rxPageId.next(id);
      rxUserName.next(username);
      fetchPageInfo(id);
      rxIsLoading.next('');
    });
};

const loadEditData = (id) => {
  const data = {
    action: 'load',
    id: id,
  };
  const accessData = {
    action: 'check-access',
    id: id,
    token: getToken(),
  }
  return api(API_PAGES, 'POST', accessData)
  .then(resp => {
    if (resp.success) {
      return api(API_PAGES, 'POST', data) //TODO: WTF! need to move this in to single server call instead of two
      .then((data) => {
        console.log('GOT DATA:', data);
        return data;
      })
      .catch((error) => {
        console.error('loading pages error', error);
      });
    } else {
      return new Error(resp.error);
    }
  }).catch((error) => {
    console.error('loading pages error', error);
  });

};

const loadLiveData = async (pageName, pageId) => {
  console.log("load LIVE data", pageName);
  return new Promise((resolve, reject) => {
    let data;
    if (document.getElementById('page-data') === null) {
      const itemName = `liveData-${pageId}-${pageName}`;
      const json = localStorage.getItem(itemName);

      if(json == null){
        console.log(`page: ${pageId} not found in cache, fetching`);
        const request = {
          action: 'load',
          id: pageId,
        };

        api(API_PAGES, 'POST', request) //TODO: need to add token and verification mechanisms
        .then((data) => {
          //console.log("data", data);
          resolve(data);
        })
      }
      else{
        console.log('loading from local cache');
        data = { pages: {} };
        const page = JSON.parse(json);
        data.pages[pageName] = page;

        const modalPopupKey = `liveData-${pageId}-${pageName}-modal`;
        const modalJson = localStorage.getItem(modalPopupKey);
        if(modalJson){
          console.log('loading popup data form local cahce');
          data.pages[pageName].exitpopupdata = JSON.parse(modalJson);
        }

        data.stripePublicKey = page.stripePublicKey;
        data.products = page.products;

        console.log('data', data);
        resolve(data);
      }

    } else {
      const json = document.getElementById('page-data').innerHTML;
      data = { pages: {} };
      const page = JSON.parse(json);
      data.pages[pageName] = page;
      data.order = [{id: page._id, parent_id: 0}];
      data.stripePublicKey = page.stripePublicKey;
      data.products = page.products;

      resolve(data);
    }

  });
};

const fetchPageInfo = (pageId) => {
  let request = {
    pageId: pageId,
    action: 'projectInfo'
  }
  api(API_PROJECT, 'POST', request)
    .then((data) => {
    if (data && data.pageName) {
      rxProjectName.next(data.projectName);
      rxPageName.next(data.pageName);
      rxProjectId.next(data.projectId);
    }
  });
};

const getCache = () => {
  const data = localStorage.getItem('SHOMIO_CACHE');
  localStorage.removeItem('SHOMIO_CACHE');
  return data ? JSON.parse(data) : null;
}
